import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RandomQuote from "../../components/RandomQuote/RandomQuote";
import { useTranslation } from "react-i18next";

const VerifyPage = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // 'verifying', 'success', 'error'

  const [resendEmail, setResendEmail] = useState("");
  const [resendMessage, setResendMessage] = useState("");

  const handleResendVerification = async () => {
    setResendMessage("");
    try {
      const res = await fetch(
        `${import.meta.env.VITE_API_URL}/api/auth/resend-verification`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: resendEmail }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || t("auth.verify.resendFailed"));

      setResendMessage(t("auth.verify.resent"));
    } catch (err) {
      setResendMessage(`${err.message}`);
    }
  };

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const res = await fetch(
          `${import.meta.env.VITE_API_URL}/api/auth/verify/${token}`
        );
        const data = await res.json();

        if (!res.ok) throw new Error(data.error || "Verification failed");

        setStatus("success");
        setTimeout(() => navigate("/login"), 3000);
      } catch (err) {
        console.error("Verification error:", err);
        setStatus("error");
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="authentication-view">
      <div className="center-wrapper">
        {status === "verifying" && <p>{t("auth.verify.verifying")}</p>}
        {status === "success" && (
          <p>&nbsp;&nbsp;{t("auth.verify.success")}</p>
        )}
        {status === "error" && (
          <>
            <h2>{t("auth.verify.failedTitle")}</h2>
            {t("auth.verify.invalidLink")}
            <br />
            <p>{t("auth.verify.enterEmail")}</p>
            <input
              type="email"
              placeholder={t("auth.verify.emailPlaceholder")}
              value={resendEmail}
              onChange={(e) => setResendEmail(e.target.value)}
              className="flow-form-resend"
              required
            />
            <div className="options">
              <button
                className="flow-verification-button"
                onClick={handleResendVerification}
              >
                {t("auth.verify.resend")}
              </button>
              {resendMessage && <p>{resendMessage}</p>}
              <p>
                <a className="link" href="/login">
                  &larr;{t("auth.verify.backToLogin")}
                </a>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyPage;
